import { eventsDuck } from '@eb/redux-destination';
import {
    CreatorCollection,
    FormattedCreatorCollection,
    PublicCollections,
} from '../../types';

interface Signal {
    signal?: {
        type: 'follow' | 'collection';
        value: number | CreatorCollection[] | FormattedCreatorCollection[];
    };
}

interface SignalCandidate {
    collection?: PublicCollections;
    follow: number;
}

export const loggedOutSaveRedirect = (eventId: string) => {
    eventsDuck.api.loggedOutSaveRedirect(eventId, {
        pathname: window.location.pathname,
    });
};

export const getSignal = (signalCandidates: SignalCandidate): Signal => {
    if (
        signalCandidates?.collection?.creatorCollections &&
        signalCandidates?.collection?.creatorCollections?.length > 0
    ) {
        return parseCollectionSignal(signalCandidates.collection);
    }

    if (signalCandidates.follow) {
        return parseFollowSignal(signalCandidates.follow);
    }

    return {};
};

export const parseFollowSignal = (organizerFollowCount: number): Signal => {
    if (organizerFollowCount >= 10) {
        return {
            signal: { type: 'follow', value: organizerFollowCount },
        };
    }

    return {};
};

export const parseCollectionSignal = (
    publicCollections: PublicCollections,
): Signal => {
    const collections = publicCollections?.creatorCollections || [];

    if (collections.length > 0) {
        return {
            signal: {
                type: 'collection',
                value: collections,
            },
        };
    }

    return {};
};
